import React from 'react'
import PropTypes from 'prop-types'
import ForgottenPassword from './ForgottenPassword'
import Agreement from './Agreement'
import './index.css'

const psw_t_p = 'password'
const psw_t_t = 'text'
const psw_v_p = 'psw-vis-on'
const psw_v_t = 'psw-vis-off'
const psw_tit_p = 'Zobrazit heslo'
const psw_tit_t = 'Skrýt heslo'

export default class LoginForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      pswType: psw_t_p,
      pswVisibility: psw_v_p,
      pswTitle: psw_tit_p,
      agreement: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handlePswVisibilityClick = this.handlePswVisibilityClick.bind(this)
    this.handleChbChanged = this.handleChbChanged.bind(this)
  }

  handleSubmit () {
    this.props.onSubmit(this.name ? this.name.value : null, this.email.value,
      this.password.value, this.passwordC ? this.passwordC.value : null, this.state.agreement)
  }

  handlePswVisibilityClick () {
    const { pswType } = this.state
    if (pswType === psw_t_p) {
      this.setState({
        pswType: psw_t_t,
        pswVisibility: psw_v_t,
        pswTitle: psw_tit_t
      })
    } else {
      this.setState({
        pswType: psw_t_p,
        pswVisibility: psw_v_p,
        pswTitle: psw_tit_p
      })
    }
  }

  handleChbChanged (e) {
    this.setState({
      agreement: e.value
    })
  }

  render () {
    const { register, onCancel, name, email, password, passwordC, forRelogin } = this.props
    const lfbCls = register ? 'lf-b' : 'lf-b m-n'
    return (
      <div className='lf'>
        {!forRelogin
          ? <h2 className='lf-h2'>{register ? 'Vytvořit nový účet' : 'Přihlásit se do Dadopa'}</h2>
          : null
        }
        {register
          ? <div className='lf-l'>
              <span className='lf-s c-1'>Uživatelské jméno</span>
              <input className='lf-i' type="text" ref={(input) => { this.name = input }}
                defaultValue={name} />
            </div>
          : null
        }
        <div className='lf-l'>
          <span className='lf-s c-1'>E-mail</span>
          <input className='lf-i' type="email" ref={(input) => { this.email = input }}
            defaultValue={email} />
        </div>
        <div className='lf-l'>
          <span className='lf-s c-1'>Heslo</span>
          <input className='lf-i lf-i-p' type={this.state.pswType}
            ref={(input) => { this.password = input }} defaultValue={password} />
          <span className={`psw-vis ${this.state.pswVisibility}`}
            onClick={this.handlePswVisibilityClick} title={this.state.pswTitle} />
          {!register
            ? <ForgottenPassword onReset={e => this.props.onPasswordReset(this.email.value)}/>
            : null
          }
        </div>
        {register
          ? <div className='lf-l'>
              <span className='lf-s c-1'>Potvrzení hesla</span>
              <input className='lf-i lf-i-p' type={this.state.pswType}
                ref={(input) => { this.passwordC = input }} defaultValue={passwordC} />
              <span className={`psw-vis ${this.state.pswVisibility}`}
                onClick={this.handlePswVisibilityClick} title={this.state.pswTitle} />
            </div>
          : null
        }
        <div>
          {register
            ? <Agreement onChange={this.handleChbChanged} agreement={this.state.agreement} />
            : null
          }
        </div>
        <div className='lf-but-con'>
          <button className={lfbCls} onClick={this.handleSubmit}>
            {register ? 'Vytvořit' : (forRelogin ? 'OK' :'Přihlásit')}
          </button>
          <button className={lfbCls} onClick={onCancel}>Zrušit</button>
        </div>
      </div>
    )
  }
}

LoginForm.propTypes = {
  register: PropTypes.bool,
  forRelogin: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPasswordReset: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/UserForms/FormLogin.js